import type React from "react";

const Footer: React.FC = () => {
	return (
		<footer className="bg-gray-800 text-white py-8">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<p className="text-center">
					&copy; 2024 Ofunato MokuMoku. All rights reserved.
				</p>
			</div>
		</footer>
	);
};

export default Footer;
